const state = {
  gasHomeGasData: {}
}

const getters = {
  gasHomeGasData: state => state.gasHomeGasData
}

const actions = {
  setGasHomeGasData ({ commit }, data) {
    commit('setGasHomeGasData', data)
  }
}

const mutations = {
  setGasHomeGasData (state, data) {
    state.gasHomeGasData = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/weixin/gas_home.js